class ServerStatusService {
  private static instance: ServerStatusService;
  private setServerReachableCallback: ((reachable: boolean) => void) | null = null;

  static getInstance(): ServerStatusService {
    if (!ServerStatusService.instance) {
      ServerStatusService.instance = new ServerStatusService();
    }
    return ServerStatusService.instance;
  }

  setCallback(callback: (reachable: boolean) => void) {
    this.setServerReachableCallback = callback;
  }

  notifyServerError() {
    if (this.setServerReachableCallback) {
      this.setServerReachableCallback(false);
    }
  }

  notifyServerReachable() {
    if (this.setServerReachableCallback) {
      this.setServerReachableCallback(true);
    }
  }
}

export const serverStatusService = ServerStatusService.getInstance();